import React from 'react';

import OddsDown from '@/assets/icons/odds-down';
import OddsUp from '@/assets/icons/odds-up';
import { AnimatedFadeOutView } from '@/components/AnimatedFadeOutView';

type AnimatedOddsChangeIconProps = {
    hasOddsChanged: boolean;
    previousOdds: number | null;
    odds: number | null;
};

export const AnimatedOddsChangeIcon = ({ hasOddsChanged, previousOdds, odds }: AnimatedOddsChangeIconProps) => {
    if (!hasOddsChanged || !previousOdds || !odds) {
        return null;
    }

    return (
        <AnimatedFadeOutView>
            {odds > previousOdds ? <OddsUp /> : null}
            {odds < previousOdds ? <OddsDown /> : null}
        </AnimatedFadeOutView>
    );
};
